require('./vendor/jquery.hoverIntent');
require('slick-carousel');
require('jquery-confirm');

require('../hushcms/js/redactor/redactor.min.js');
require('../hushcms/js/redactor/counter.min.js');
require('../hushcms/js/redactor/table.min.js');
require('../hushcms/js/redactor/video.min.js');
require('../hushcms/js/redactor/imagemanager.js');
require('../hushcms/js/redactor/filemanager.js');
require('../hushcms/js/redactor/alignment.min.js');
require('../hushcms/js/redactor/button.js');
require('./vendor/featherlight.min');
require('./vendor/featherlight.gallery');
require('./cookie.js');

var viewportWidth = window.innerWidth;

var allVideos;

// NAVIGATION ------------------------------
require('./_navigation.js');

var InfiniteScroll = require('infinite-scroll');
var AOS = require('aos');
import 'aos/dist/aos.css';

jQuery(document).ready(function ($) {

	AOS.init();

	jconfirm.defaults = {
		draggable: false,
		useBootstrap: false,
		boxWidth: '50rem',
		type: 'blue',
		typeAnimated: false
	};

	if ($("#product-container").length && $('.pagination li').length) {
		var infScroll = new InfiniteScroll('#product-container', {
			// options
			path: '.pagination li:last-child a',
			checkLastPage: true,
			append: '.list_item',
			history: false,
			scrollThreshold: 10,
			debug: false,
		});
	}

	$('.product_tabbed_content .tabs button:first-of-type').addClass("active"); // turn on first desktop button
	$('.product_tabbed_content .content > div > button:first-of-type').addClass("active"); // turn on first mobile button
	$('.product_tabbed_content .tab_content:first-of-type').addClass("active");  // turn on first tab content
	// handle desktop button clicks
	$('.product_tabbed_content .tabs button').on("click", function () {
		var index = $(this).index();
		$('.product_tabbed_content .tabs button').removeClass('active'); // turn off all desktop buttons
		$(this).addClass('active'); // turn on specific desktop button
		$('.product_tabbed_content .content > div > button').removeClass('active'); // turn off all mobile buttons
		$('.product_tabbed_content .content > div > button').eq(index).addClass('active'); // turn on specific mobile button
		$('.product_tabbed_content .tab_content').removeClass('active'); // turn off all tab contents
		$('.product_tabbed_content .tab_content').eq(index).addClass('active');  // turn on specific tab content
		fluidVideos();
	});
	// handle mobile button clicks
	$('.product_tabbed_content .content > div > button').on("click", function () {
		var index = $(this).index() / 2;
		$('.product_tabbed_content .tabs button').removeClass('active'); // turn off all desktop buttons
		$('.product_tabbed_content .tabs button').eq(index).addClass('active'); // turn on specific desktop button
		$('.product_tabbed_content .content > div > button').removeClass('active'); // turn off all mobile buttons
		$(this).addClass('active'); // turn on specific mobile button

		$('.product_tabbed_content .tab_content').removeClass('active'); // turn off all tab contents
		$(this).next('.tab_content').toggleClass('active'); // turn on specific tab content
		fluidVideos();
	});

	if ($("#product_review_list").length) {
		const resizeObserver = new ResizeObserver(entries => {
			for (let entry of entries) {
				var container_height = $(entry.target).outerHeight();
				var content_height = $(entry.target)[0].scrollHeight;
				if (content_height > container_height) {
					$(entry.target).addClass("scrollable");
				} else {
					$(entry.target).removeClass("scrollable");
				}
			}
		});
		resizeObserver.observe(document.querySelector('#product_review_list'));
	}

	viewportWidth = window.innerWidth;
	window.requestAnimationFrame(scrollHandler);
	window.requestAnimationFrame(resizeHandler);

	if ($(".map_element").length) {
		initMap();
	}


	$('.form_style :required').prev('label').addClass('required');

	// STYLED SELECT BOXES //
	$('.form_style select, .styled_select').each(function () {
		if (!$(this).parent().hasClass('select_wrapper')) {
			$(this).wrap('<div class="select_wrapper"></div>');
		}
	});

	$('#checkout_form').bind("keypress", function (e) {
		if (e.keyCode == 13) {
			return false;
		}
	});

	$('.sticky_bar .text').slick({
		vertical: true,
		adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 1000,
		pauseOnHover: true,
		arrows: false,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0,
		responsive: [
			{
				breakpoint: 768,
				settings: "unslick"
			}
		]
	});

	$('.homepage_carousel .slides').slick({
		adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 1000,
		pauseOnHover: false,
		arrows: false,
		dots: true,
		cssEase: 'ease-in-out',
		rows: 0
	})
		// .on('afterChange', function (event, slick, currentSlide) {
		// 	$(".homepage_carousel .slides").slick('slickSetOption', 'autoplaySpeed', 9000, true);
		// })
	;

	$('.main_image_carousel ul').slick({
		adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: false,
		infinite: true,
		autoplay: false,
		speed: 600,
		arrows: false,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0
	});

	$('#product_image_thumbnails li').click(function () {
		if (typeof $(this).data('index') !== 'undefined') {
			var index = $(this).data('index');
			$('.main_image_carousel ul').slick('slickGoTo', index);
		}
	});

	$('.product_usps ul').slick({
		adaptiveHeight: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		swipeToSlide: true,
		fade: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 600,
		arrows: false,
		dots: true,
		cssEase: 'ease-in-out',
		rows: 0,
		prevArrow:"<button type='button' class='slick-prev'><i class='fal fa-long-arrow-left' aria-hidden='true'></i></button>",
		nextArrow: "<button type='button' class='slick-next'><i class='fal fa-long-arrow-right' aria-hidden='true'></i></button>",
		responsive: [
			{
				breakpoint: 451,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

 $('.featured_products_carousel .grid').slick({
		adaptiveHeight: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		infinite: true,
		autoplay: true,
		speed: 600,
		arrows: true,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0,
		prevArrow:"<button type='button' class='slick-prev'><i class='fal fa-long-arrow-left' aria-hidden='true'></i></button>",
		nextArrow: "<button type='button' class='slick-next'><i class='fal fa-long-arrow-right' aria-hidden='true'></i></button>",
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 450,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	$('.subcategories > div').each(function () {
		var num_slides = $(this).children().length;
		var max_slides = 3;
		if (num_slides == 2) { max_slides = 2; }
		$(this).slick({
			adaptiveHeight: false,
			slidesToShow: max_slides,
			slidesToScroll: 1,
			swipeToSlide: true,
			fade: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			speed: 1000,
			arrows: true,
			dots: false,
			cssEase: 'ease-in-out',
			rows: 0,
			appendArrows: $('.subcategories > div'),
			prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left' aria-hidden='true'></i></button>",
			nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right' aria-hidden='true'></i></button>",
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 450,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	});


	$('.more').each(function () {
		var min_initial = 180;
		if ($(this).parent().hasClass('product_description')) {
			var min_initial = 480;
		}


		$(this).wrapInner("<div class='inner'></div>");
		var initial_height = $(this).find('.inner').outerHeight();
		if (initial_height > min_initial) {
			$(this).addClass('reduced').parent().append('<p class="more_button"><span class="button">Read More</span></p>');
		} else {
			$(this).css('height','auto');
		}
	});
	$('.more_button span').click(function () {
		var more_div = $(this).parent().prev();
		more_div.css('height', more_div.find('.inner').outerHeight()); // set the height of the div so the transition can work
		$(this).text($(this).text() == "Read More" ? "Show Less" : "Read More"); // toggle the text in the button
		more_div.toggleClass('reduced'); // toggle the class on the div
	});

	$('.filters input').change(function () {
		$(this).closest('form').submit();
	});

	$('#clear_filter').click(function () {
		$(this).siblings('form').find(':checkbox, :radio').prop('checked', false);
		$(this).siblings('form').submit();
	});

	$('#filter_button').click(function () {
		$(this).toggleClass('active');
		$('.filters').slideToggle();
	});

	$('.active_filters li').click(function () {
		$("[id='"+$(this).data('tag')+"']").prop( "checked", false ).trigger('change');
	});

	$('#sort_select').change(function () {
		var the_value = $(this).val();
		$('#sort_field').val(the_value).closest('form').submit();
	});

	$('.homepage_products button').on("click", function () {
		$('.homepage_products button').removeClass('active');
		$(this).addClass('active');
		$('.homepage_products .card_list > div').removeClass('active');
		$('#' + $(this).data('section')).addClass('active');
	});

	$('.auth_tabs li').on("click", function () {
		$('.auth_tabs li').removeClass('active');
		$(this).addClass('active');
		$('.auth_tab_content').removeClass('active');
		$('.auth_tab_content').eq($(this).index()).addClass('active');
	});

	$('input[name=account_type]').change(function () {
		auth_buttons();
	});
	auth_buttons();

	function auth_buttons(){
		var checked_value = $('input[name=account_type]:checked').val();
		if (checked_value == 'trade_customer') {
			$('.extra_fields').show();
			$('.extra_fields').find("input[type=text][data-required='true']").attr('required', 'required').prev('label').addClass('required');
			if ($('#trade_category').val() == 'Other') {
				$('#trade_category_other_p').show();
				//$('#trade_category_other_p input').prev('label').addClass('required');
			} else {
				$('#trade_category_other_p').hide();
				//$('#trade_category_other_p input').prev('label').removeClass('required');
			}
		} else {
			$('.extra_fields').hide();
			$('.extra_fields').find("input[type=text][data-required='true']").removeAttr('required').prev('label').removeClass('required');
		}
	}

	$('#trade_category').change(function () {

		if ($('#trade_category').val() == 'Other') {
			$('#trade_category_other_p').show();
			//$('#trade_category_other_p input').prev('label').addClass('required');
		} else {
			$('#trade_category_other_p').hide();
			//$('#trade_category_other_p input').prev('label').removeClass('required');
		}
	});

	$('.wysiwyg').redactor({
		pastePlainText: true,
		pasteImages: false, // prevent pasting images
		toolbar: false,
		minHeight: '300px'
	});

	$('.product_calculator_header').click(function () {
		$('.product_calculator_inner').slideToggle();
	});

    // Multiple images preview in browser
	var imagesPreview = function (input, placeToInsertImagePreview) {
		if (input.files) {
			$(placeToInsertImagePreview).html('');
            var filesAmount = input.files.length;
            for (i = 0; i < filesAmount; i++) {
                var reader = new FileReader();
                reader.onload = function(event) {
                    $($.parseHTML('<img>')).attr('src', event.target.result).appendTo(placeToInsertImagePreview);
                }
                reader.readAsDataURL(input.files[i]);
            }
        }
    };

    $('#images').on('change', function() {
        imagesPreview(this, '#image_preview');
	});

	if ($(".story_children").length) {
		$(".story_children .text_inner").css('opacity', '1');
	}

	// RESPONSIVE VIDEO
	allVideos = $("iframe[src^='https://www.youtube'], iframe[src^='//www.youtube'], iframe[src^='https://player.vimeo.com'], iframe[src^='//player.vimeo.com']");
	// Figure out and save aspect ratio for each video
	allVideos.each(function() {

		var the_width = $(this).width();
		var the_height = $(this).height();

			$(this)
			.attr('data-aspectratio', the_height / the_width)
			.attr('data-maxwidth', the_width)
			.attr('data-maxheight', the_height)
			.css('margin-bottom','calc(2vw + 2.0rem)')
			.css('max-width','100%');

	});
	fluidVideos();
	if ($(".sample_item.active").length) {
		var el = $(".sample_item.active");
		var elOffset = el.offset().top;
		var elHeight = el.height();
		var windowHeight = $(window).height();
		var offset;
		if (elHeight < windowHeight) {
			offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
		}
		else {
			offset = elOffset;
		}
		var speed = 700;
		$('html, body').animate({scrollTop:offset}, speed);
	}

	// DO NOT CHANGE - trigger function when window scrolls
	$(window).scroll(function () {
		window.requestAnimationFrame(scrollHandler);
	});

	// DO NOT CHANGE - trigger function when window resizes
	$(window).resize(function() {
		window.requestAnimationFrame(resizeHandler);
	});

	// DO NOT CHANGE - trigger function when mouse moves
	$(document).on('mousemove',function(e){
		var xpos = e.clientX;
		var ypos = e.clientY;
		window.requestAnimationFrame(mouseHandler);
    });

	function resizeHandler() {
		viewportWidth = window.innerWidth;

		if ($(".story_children").length) {
			$('.story_children .item h2').each(function () {
				var h2_height = $(this).outerHeight();
				$(this).parent().css('top', 'calc(50% - ' + (h2_height / 2) + 'px) ');
			});
		};

		fluidVideos();
	}


	// Story JS

	// Initialise Skrollr
	if($('#story_page').length){

		if ($(window).width() > 992) {
	    	var s = skrollr.init({documentElement : "story_page"});
	  	}
	  	$(window).on('resize', function () {
	    	if ($(window).width() <= 992) {
	      		s.destroy(); // skrollr.init() returns the singleton created above
	    	}
	  	});
	};

	if( $('.story__top__content h2').length){
		var words = $('.story__top__content h2').text().split(" ");
		$('.story__top__content h2').empty();
		$.each(words, function(i, v) {
		    $('.story__top__content h2').append($("<span>").text(v + " "));
		});
		var totalSpans = $(".story__top__content h2 span").length;
		$('.story__top__content h2').show();
		setTimeout(function () {
	        $(".story__top__content").addClass("animateIn");
	    }, 1000);
	}

	$('.story__top__content__scroll').click(function(){
		if($(window).width() > 992) {
			var headerHeight = $('.header').outerHeight();
		} else {
			var headerHeight = 0;
		}

		if($('.story__scroller-content').length) {
			var windowHeight = $(window).height();
			var scrollerHeight = $('.story__scroller-content').outerHeight();
			if(scrollerHeight < windowHeight) {
				var target = $('.story__scroller-content').offset().top - (windowHeight - scrollerHeight);
			} else {
				var target = $('.story__scroller-content').offset().top - headerHeight;
			}
		} else if($('.story__video').length){
			var windowHeight = $(window).height();
			var videoHeight = $('.story__video').outerHeight();
			if(videoHeight < windowHeight) {
				var target = $('.story__video').offset().top - (windowHeight - videoHeight);
			} else {
				var target = $('.story__video').offset().top - headerHeight;
			}
		} else if($('.story__tabs').length){
			var target = $('.story__tabs').offset().top - headerHeight;
		}
		if(target){
			$('html, body').animate({
				scrollTop: target
			}, 2500);
		}
	});

	$('.story__video__scroll').click(function(){
		if($(window).width() > 992) {
			var headerHeight = $('.header').outerHeight();
		} else {
			var headerHeight = 0;
		}
		if($('.story__tabs').length){
			$('html, body').animate({
				scrollTop: $('.story__tabs').offset().top - headerHeight
			}, 1500);
		}
	});

	if( $('.story__tabs__nav').length ){
		setStoryTabsNavActive();
	}
	$('.story__tabs__nav ul li').click(function(){
		if(!$(this).hasClass("active")){
			var index = $(this).index();

			// Set Active State of Navigation
			$(this).parent().find('li.active').removeClass("active");
			$(this).addClass("active");
			setStoryTabsNavActive();

			// Show Selected Tab Content
			$('.story__tabs__content').slick('slickGoTo', index);
		}
	})

	$('.story__tabs__content').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		infinite: true,
		autoplay: false,
		speed: 700,
		arrows: false,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0
	});

	//Story Scroll Fading
	$(document).scroll(function(){
		$('.story__scroller-content__block').each(function(){
			if ($(this).offset().top < ($(window).scrollTop() + ($(window).height() / 2))) {
				var areaTarget = $(this).index();
				$('.story__scroller-fixed__bg').removeClass("active");
				$('.story__scroller-fixed__bg').eq(areaTarget).addClass("active");
			}
		});
	})

	// Scroll Navigation
	$('a[href^="#"]').click(function(event){
		var href = $(this).attr('href');
		event.preventDefault();
			if(href == '#top' || href == '#home') {
				$('html, body').stop().animate({
			        scrollTop: 0
			    }, 1000);
			} else if($(href).length){
				var headerHeight = $('.header').outerHeight();
				$('html, body').stop().animate({
			        scrollTop: $(href).offset().top - headerHeight
			    }, 1000);
			} else {
				console.log("target ID doesn't exist");
			}
		// }
	});

	$.featherlightGallery.prototype.afterContent = function() {
		var caption = this.$currentTarget.data('caption');
		this.$instance.find('.caption').remove();
		if (caption != '') {
			$('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
		}
	  };

});

$(window).resize(function() {
	if( $('.story__tabs__nav').length ){
		setStoryTabsNavActive();
	}
});

function setStoryTabsNavActive() {
	var activeWidth = $('.story__tabs__nav ul li.active').css("width");
	var activeMarginLeft = $('.story__tabs__nav ul li.active').css("margin-left");
	var activePosition = $('.story__tabs__nav ul li.active').position();
	var activeLeft = activePosition.left + parseInt(activeMarginLeft, 10);
	$('.story__tabs__nav__active').css({"width":activeWidth, "transform":"translateX(" + activeLeft + "px)"});
}

function scrollHandler() {
	var topOfViewport = $(window).scrollTop();
	var bottomOfViewport = topOfViewport + $(window).height();
}

function mouseHandler() {
}

$(() => {
	const stuckClass = 'stuck';
	const $stickyTopElements = $('.header');

	const determineSticky = () => {
		$stickyTopElements.each((i, el) => {
			const $el = $(el);
			const currTop = $(window).scrollTop();
			const isStuck = currTop > 100;

			if (viewportWidth <= 1023) {
				$el.removeClass(stuckClass);
			} else {
				if ($el.hasClass(stuckClass) && currTop < $el.outerHeight() - 20 ) {
					$el.removeClass(stuckClass);
				}
				if (!$el.hasClass(stuckClass) && currTop > $el.outerHeight() - 20 ) {
					$el.addClass(stuckClass);
				}
			}
		});
	};

	//Run when the browser is resized or scrolled
	$(window).on('resize scroll', () => {
		determineSticky();
	});

});

function initMap() {
	$('.map_element').each(function () {
		if ($(this).data('extra_markers') && $(this).data('extra_markers') != '') {
			multiMapInit($(this));
		}else{
			simpleMapInit($(this));
		}
	});
}

function simpleMapInit($element) {
	var the_center;
	var lat = parseFloat($element.data('latitude'));
	var lng = parseFloat($element.data('longitude'));
	var zoom = parseInt($element.data('zoom'));
	var the_center = { lat: lat, lng: lng };
	var map = new google.maps.Map($element[0], {
		zoom: zoom,
		center: the_center,
		scrollwheel: false,
		mapTypeControl: false,
		draggable: true,
		streetViewControl: false,
		zoomControl: true,
		panControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	});

	var marker = new google.maps.Marker({
		position: the_center,
		map: map,

	});
	google.maps.event.addDomListener(window, 'resize', function() {
		mapcenter(map, the_center);
	});
}

function mapcenter(map, the_center) {
	map.setCenter(new google.maps.LatLng(
		the_center
	));
}


function multiMapInit($element) {
	var bounds = new google.maps.LatLngBounds();
	var infowindow = new google.maps.InfoWindow();
	var markers = [];

	var suppliersData = $element.data('extra_markers');

	var suppliers = [
		//['title','lat', 'long','window', 'pin'],
	];

	for (i = 0; i < suppliersData.length; i++) {
		var $img = suppliersData[i].logo;

		var $title = suppliersData[i].name;
		var $lat   = suppliersData[i].latitude;
		var $lng   = suppliersData[i].longitude;
		var $desc  = suppliersData[i].content;

		var $window = '';
		if($img) { $window = $window  + '<div class="info-img" style="background-image:url(' + $img + ');"></div>' }
		$window = $window  + '<div class="info-content"><h4>' + $title + '</h4><p>' + $desc + '</p></div>';
		var $pin = '/images/pin.png';
		suppliers.push([$title, $lat, $lng, $window, $pin]);
	}

	var mapOptions = {
		disableDefaultUI: true,
		zoomControl: true,
		zoomControlOptions: {position: google.maps.ControlPosition.LEFT_BOTTOM},
		streetViewControl: false,
		mapTypeControl: true,
	};
	var map = new google.maps.Map($element[0], mapOptions);

	var marker, i;

	for (i = 0; i < suppliers.length; i++) {
		marker = new google.maps.Marker({
			position: new google.maps.LatLng(suppliers[i][1], suppliers[i][2]),
			map: map,
			title: suppliers[i][0],
			animation: google.maps.Animation.DROP,
			icon: { url: suppliers[i][4], scaledSize: new google.maps.Size(38, 52), origin: new google.maps.Point(0,0), anchor: new google.maps.Point(19, 52) }
		});

		//extend the bounds to include each marker's position
		bounds.extend(marker.position);
		markers.push(marker);
		google.maps.event.addListener(marker, 'click', (function(marker, i) {
			return function() {
				infowindow.setContent(suppliers[i][3]);
				infowindow.open(map, marker);
		}
		})(marker, i));

		// Automatically center the map fitting all suppliers on the screen
        map.fitBounds(bounds);
	}

    google.maps.event.addListener(infowindow, 'domready', function() {

	   // Reference to the DIV which receives the contents of the infowindow using jQuery
	   var iwOuter = $('.gm-style-iw');

	   /* The DIV we want to change is above the .gm-style-iw DIV.
	    * So, we use jQuery and create a iwBackground variable,
	    * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
	    */
	   var iwBackground = iwOuter.prev();
	   iwBackground.css({'z-index' : '1'});
	   iwBackground.children(':nth-child(2)').css({'display' : 'none'});
	   iwBackground.children(':nth-child(4)').css({'display' : 'none'});

	});
};


function fluidVideos() {
	// Resize all videos according to their own aspect ratio
	allVideos.each(function() {
		var $el = $(this);
		var newWidth = $(this).parent().width();
		$el
			.width(newWidth)
			.height(newWidth * $el.data('aspectratio'));
	});
}

window.openPopup = function(title, content, bg, hide_title, use_padding, cookie) {

	var popup_class = "popup_message";
	if (hide_title == 'true') { popup_class += " hide_title"; }
	if (use_padding == 'true') { popup_class += " use_padding"; }

	$.featherlight({
		variant: 'custom_popup',
		contentFilters: ['html'],
		otherClose: 'a.close',
		html: '<div class="'+popup_class+'"><h1>' + title + '</h1>' + content + '</div>',
		beforeOpen: function (event) {
			$('.custom_popup .featherlight-content').css('background-image', 'url(' + bg + ')');
		},
		afterClose: function(event) {
			var expires = new Date();
			expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000));
			document.cookie = cookie + '=1;expires=' + expires.toUTCString();
		}
	});

}
